import { isJust, Maybe } from '@execonline-inc/structured-maybe';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';
import LearningCollectionStore from '../../Store';
import ToggleButton from './ToggleButton';

export interface Props {
  publishedAt: Maybe<Date>;
  learningCollectionStore: LearningCollectionStore;
}

const Published: React.FC<Props> = ({ publishedAt, learningCollectionStore }) => {
  const published = isJust(publishedAt);

  return (
    <div className="mt-10 flex">
      <p className="mr-2 font-semibold">
        <T kind="Published" />
      </p>
      {findLink('publish', learningCollectionStore.links)
        .map(() => (
          <ToggleButton
            cursorClassName="cursor-pointer"
            handleOnClick={() => learningCollectionStore.publishing()}
            value={published}
          />
        ))
        .getOrElse(() => (
          <ToggleButton
            cursorClassName="cursor-not-allowed"
            handleOnClick={() => {}}
            value={published}
          />
        ))}
    </div>
  );
};

export default observer(Published);
